{
  "title": "Choisissez votre affichage",
  "description": "Salt met en avant les prédications, les services et plus encore pour l'affichage que vous sélectionnez ci-dessous.",
  "noLaunchpadsTitle": "Rien à choisir",
  "noLaunchpadsDescription": "Cette église n'a configuré aucun affichage, il n'y a donc aucun contenu à afficher."
}
